import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/core/_base/services/config.service';

@Component({
  selector: 'app-exit',
  templateUrl: './exit.component.html',
  styles: [
  ]
})
export class ExitComponent implements OnInit {
  url: string='';
  title: string = '';
  text1: string = '';
  text2: string = '';

  constructor(private configS: ConfigService) { }

  ngOnInit(): void {
    this.url = String(this.configS.getValue('LINK_ONBOARDING'));
    this.title = String(this.configS.getValue('EXIT_ESPERE'));
    this.text1 = String(this.configS.getValue('EXIT_TXT_1'));
    this.text2 = String(this.configS.getValue('EXIT_TXT_2'));
    window.location.assign(this.url);
  }

}
